import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DriverService } from '../services/driver.service';
import { ToastService } from '@shared/services/toast.service';
import { autoUnsubWith } from '@shared/services/utility.abstract';

@Component({
  selector: 'app-add-notes',
  templateUrl: './add-notes.component.html',
  styleUrls: ['./add-notes.component.scss']
})
export class AddNotesComponent implements OnInit {
  readonly destroyRef = inject(DestroyRef);
  driverId: string;
  driverName: string;
  driverNotesForm: FormGroup;

  constructor(
    private readonly ref: DynamicDialogRef,
    private readonly fb: FormBuilder,  
    private readonly toastService: ToastService,
    private readonly driverService: DriverService, 
    private readonly config: DynamicDialogConfig,
  ) { };

  ngOnInit() {
    this.driverId = this.config.data?.driverId;
    this.driverName = this.config.data?.driverName
    this.driverNotesFormControl();
  }

  driverNotesFormControl() {
    this.driverNotesForm = this.fb.group({
      note: ['', [Validators.required, Validators.maxLength(512)]]
    });
  }

  closeDialog() {
    this.ref.close();
  }

  addDriverNotesHistory() {
    if (this.driverNotesForm.valid) {
      const req = {
        driverId: this.driverId,
        notes: this.driverNotesForm.value.note
      }
      
      this.addDriverNotes(req)
    }
  }

  addDriverNotes(req) {
    
    this.driverService.addDriverNotesHistoryByDriverIdForSuperAdmin(req)
    .pipe(autoUnsubWith(this.destroyRef))
      .subscribe({
        next: (response) => {
          this.closeDialog();
          this.toastService.showToastMessage('success', 'Success', response.message)
          
        },
        error: error => {
          this.closeDialog();
          this.toastService.showToastMessage('error', 'Error', error.error.message)
          
        }
      });
  }
}
